import React from 'react'
import FontAwesome from 'react-fontawesome'
import './styles.css'

const LIFESPAN = 30000

export default class ToastItem extends React.Component {

  state = {
    progress: 100,
  }

  countdownTimer = null

  componentDidMount() {
    this.startCountdown()
  }

  componentWillUnmount() {
    if (this.countdownTimer) {
      clearInterval(this.countdownTimer)
      this.countdownTimer = null
    }
  }

  startCountdown = () => {

    const startedAt = Date.now()
    this.countdownTimer = setInterval(() => {
      const elapsed = Date.now() - startedAt,
      progress = Math.max(0, 100 - (elapsed / LIFESPAN) * 100)

      if (progress <= 0) {
        if (this.countdownTimer) {
          clearInterval(this.countdownTimer)
          this.countdownTimer = null
        }
        this.setState({ progress: 0 })
        const { toast, onClose } = this.props
        if (onClose) {
          onClose(toast.id)
        }
        return
      }

      this.setState({ progress })
    }, 50)
  }

  render() {
  
    const { toast, onClose } = this.props,
    { id, title, content, type } = toast,

    icon = {
      SUCCESS: 'check-circle',
      ERROR: 'times-circle',
      WARNING: 'exclamation-triangle',
      INFO: 'info-circle'
    }[type] || 'info-circle',

    iconTextColor = {
      SUCCESS: 'text-green-700',
      ERROR: 'text-red-600',
      WARNING: 'text-orange-600',
      INFO: 'text-gray-600'
    }[type] || 'text-gray-600'

    return (
      <div className={`toast-item toast-${ type.toLowerCase() }`} role="alert" aria-live="assertive">
        <div className="toast-progress-bar" aria-hidden="true">
          <div className="toast-progress-fill" style={{ width: `${ this.state.progress }%` }} />
        </div>
        <div className="toast-main-content">
          <div className={`toast-left ${ iconTextColor }`}>
            <FontAwesome name={ icon } />
          </div>
          <div className="toast-body">
            <div className="toast-title" title={ title }>{ title }</div>
            {content && <div className="toast-content">{ content }</div>}
          </div>
          <button className="toast-close" onClick={() => onClose(id)} aria-label="close" title='Close'>
            <FontAwesome name="times" />
          </button>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Notifications/ToastItem.js